<script>

import Pager from "../../../frontend/src/components/TablePager"

export default Pager
</script>